export default __webpack_public_path__ + "static/media/CheckStep-Eligible.d93560fb.svg";